export default __webpack_public_path__ + "base/static/media/background.09fd0b30.jpg";